import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=3820078b&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"
import style0 from "./Popup.vue?vue&type=style&index=0&id=3820078b&prod&lang=scss"
import style1 from "./Popup.vue?vue&type=style&index=1&id=3820078b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820078b",
  null
  
)

export default component.exports